/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypefillinblank4Inputs */

const zh_learn_mistakestypefillinblank4 = /** @type {(inputs: Learn_Mistakestypefillinblank4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填空题`)
};

const en_learn_mistakestypefillinblank4 = /** @type {(inputs: Learn_Mistakestypefillinblank4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in Blank`)
};

const es_learn_mistakestypefillinblank4 = /** @type {(inputs: Learn_Mistakestypefillinblank4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar espacios`)
};

/**
* | output |
* | --- |
* | "Fill in Blank" |
*
* @param {Learn_Mistakestypefillinblank4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypefillinblank4 = /** @type {((inputs?: Learn_Mistakestypefillinblank4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypefillinblank4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypefillinblank4(inputs)
	if (locale === "en") return en_learn_mistakestypefillinblank4(inputs)
	return es_learn_mistakestypefillinblank4(inputs)
});
export { learn_mistakestypefillinblank4 as "learn_mistakesTypeFillInBlank" }